import { IMatchComment, IMatchComments } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidLmpMatchCommentsQuery } from './typeguards';
import { CreateLmpMatchChangeInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { LmpMatchCommentsQuery } from '../types';
import { isLive, toOptionalString, toRichString, toComment, MatchStatusType } from '../../../utils/match';


export default (obj: LmpMatchCommentsQuery): IMatchComments => {
  if (isValidLmpMatchCommentsQuery(obj)) {
    CreateLmpMatchChangeInputSchema().parse(obj.data.getMatchComments, { reportInput: true });
    const matchComments = obj.data.getMatchComments;
    const comments = matchComments.comments
      ?.map(toComment)
      .filter((comment): comment is IMatchComment => Boolean(comment));

    const payload: IMatchComments = {
      comments,
      firstCommentDate: matchComments.firstCommentDate ?? '',
      lastCommentDate: matchComments.lastCommentDate ?? '',
      competition: toRichString(matchComments.competition),
      homeTeam: toRichString(matchComments.homeTeam),
      awayTeam: toRichString(matchComments.awayTeam),
      matchStatus: matchComments.matchStatus ?? '',
      url: matchComments.url ?? '',
      isLive: isLive(matchComments.matchStatus as MatchStatusType),
      nextLink: toOptionalString(matchComments.pagination?.nextLink),
      prevLink: toOptionalString(matchComments.pagination?.prevLink),
      newPostsCount: undefined, 
      updatesBadge: undefined, 
    };

    return payload;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LmpMatchCommentsQuery object',
      data: obj,
    });
  }
};
